import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const automaticPaymentsReducer = (
  state = initialState.automaticPaymentsData,
  action
) => {
  switch (action.type) {
    case types.FETCH_AUTOMATIC_PAYMENTS_STARTED:
      return {
        ...state,
        accounts: null,
        isLoading: true,
        error: null
      };
    case types.FETCH_AUTOMATIC_PAYMENTS_SUCCEEDED:
      return {
        ...state,
        accounts: action.payload,
        isLoading: false,
        error: null
      };
    case types.FETCH_AUTOMATIC_PAYMENTS_FAILED:
      return {
        ...state,
        accounts: null,
        isLoading: false,
        error: action.payload
      };
    case types.SELECT_AUTOMATIC_PAYMENTS_ENROLLMENT_ACCOUNT:
      return {
        ...state,
        accountToEnroll: action.payload
      };
    default:
      return state;
  }
};

export default automaticPaymentsReducer;
